"use strict";

exports.__esModule = true;
exports.createStorages = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _storage = require("../utils/storage");
var _getNativeTokenName = require("../utils/get-native-token-name");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createStorages = api => {
  return {
    liquidityPool: dexShareToken => {
      return _storage.Storage.create({
        api: api,
        path: 'query.dex.liquidityPool',
        params: [dexShareToken.toTradingPair(api)]
      });
    },
    initialShareExchangeRates: dexShareToken => {
      return _storage.Storage.create({
        api: api,
        path: 'query.dex.initialShareExchangeRates',
        params: [dexShareToken.toTradingPair(api)]
      });
    },
    provisioningPool: (address, dexShareToken) => {
      return _storage.Storage.create({
        api: api,
        path: 'query.dex.provisioningPool',
        params: [address, dexShareToken.toTradingPair(api)]
      });
    },
    tradingPairs: () => {
      return _storage.Storage.create({
        api: api,
        path: 'query.dex.tradingPairStatuses.entries',
        params: []
      });
    },
    issuance: token => {
      const nativeTokenName = (0, _getNativeTokenName.getNativeTokenName)(api);
      const isNativeToken = nativeTokenName === (0, _sdkCore.forceToCurrencyName)(token);
      return _storage.Storage.create({
        api: api,
        path: isNativeToken ? 'query.balances.totalIssuance' : 'query.tokens.totalIssuance',
        params: isNativeToken ? [] : [token.toChainData()]
      });
    },
    balance: (address, token) => {
      return _storage.Storage.create({
        api: api,
        path: 'query.tokens.accounts',
        params: [address, token.toChainData()]
      });
    }
  };
};
exports.createStorages = createStorages;